import { useTranslation } from 'react-i18next';
import Breadcrumbs from '@app/components/breadcrumbs/Breadcrumbs';
import { BREADCRUMB_IDS } from '@app/configs/breadcrumbs';
import { ROUTES } from '@app/configs/routes';
import MyInvestmentDetails from '@modules/investor/components/investmentDetails/MyInvestmentDetails';
const Investment = ({ isStandalone }) => {
    const { t } = useTranslation();
    const breadcrumbsItems = [
        {
            id: BREADCRUMB_IDS.INVESTMENT_DETAILS,
            label: t('financing.breadcrumbs.investment_details'),
            path: ROUTES.investmentDetails,
        },
    ];
    return (<div className="px-4 pb-4 md:px-6 md-pb-6 flex-col leading-5">
            <div className="pb-4 leading-5 font-medium">
                <Breadcrumbs items={breadcrumbsItems} activeBreadcrumb={BREADCRUMB_IDS.INVESTMENT_DETAILS} type="investor"/>
            </div>
            <MyInvestmentDetails isStandalone={isStandalone}/>
        </div>);
};
export default Investment;
